import {
    getData,
    postRequestWithFormData,
    createQueryString,
    addSessionParams,
} from '../utils/HelperFunctions.js';
import { openPopUpWindow } from '../utils/CommonFunctions.js';

export const getAccount = (paramsObject = {}) => {
    return getData(paramsObject, 'account/view').then(res => res);
};

export const updateAccountSettings = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/update', paramsObject).then(res => res);
};

export const chargeAccount = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/charge', paramsObject).then(res => res);
};

export const removeCompanyLogo = (paramsObject = {}) => {
    return getData(paramsObject, 'account/remove_company_logo').then(res => res);
};

export const createAccount = data => {
    return postRequestWithFormData(data, 'account/create', {}, { Accept: 'application/json' }).then(
        res => res
    );
};

export const toggleSyncing = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/toggle_syncing', paramsObject).then(res => res);
};

export const toggleAutoSyncing = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/toggle_auto_syncing', paramsObject).then(
        res => res
    );
};

export const reactivateAccount = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/reactivate', paramsObject, {
        'Content-Type': 'multipart/form-data',
    }).then(res => res.Account);
};

export const deactivateAccount = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'account/deactivate', paramsObject, {
        'Content-Type': 'multipart/form-data',
    }).then(res => res.Account);
};

export const getPaymentHistory = paramsObject => {
    return getData(paramsObject, 'billingtransaction/view').then(res => res);
};

export const getMemo = paramsObject => {
    addSessionParams(paramsObject);
    let url = createQueryString(paramsObject, 'billingtransaction/memo');
    // Fixes dual-screen position centering
    openPopUpWindow('Minute7 Memo', 735, 500, url);
};

// Exchange the signed handoff token (from `/impersonate?token=...`) for an
// impersonated session (M7-365 / backend M7-384). A dedicated fetch — NOT
// `getData` — because a bad/expired token returns 401, and the shared
// `baseRequest` 401 handler force-redirects to /login; here we must surface the
// error on the landing page instead. `credentials: include` so the Set-Cookie
// (the only credential) is stored; no token is returned in the body.
export const impersonateUser = token => {
    return fetch(createQueryString({}, 'users/masquerade/exchange'), {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ token }),
    }).then(async response => {
        const body = await response.json().catch(() => ({}));
        if (response.status >= 200 && response.status < 300) {
            return body;
        }
        // Carry the machine-readable code (token_replayed/target_missing/
        // token_invalid) so the landing page can show the right message.
        const error = new Error(body.error || 'Impersonation exchange failed');
        error.status = response.status;
        error.code = body.code;
        error.response = response;
        throw error;
    });
};

// Stop impersonating = the unified, impersonation-aware logout (M7-384). It
// ends only the :user scope (the admin's RailsAdmin session survives) and
// returns `{ ended: true, location }`; the saga obeys `location`.
export const exitImpersonateUser = () => {
    return getData({}, 'login/logout').then(res => res);
};

export const verifyPromoCode = data => {
    return getData(data, 'promo_code/verify').then(response => response);
};
